<script>
import ClientesService from '@/services/clientes.service';
import { PaginacionDefault, VALOR_NUMERICO_TRUE, Rol } from '@/constants/global';
import Utils from '@/functions/utils';
import authService from '@/services/auth.service';
import spinnerService from '@/services/spinner.service';
import { STORAGE_URL } from '@/config/config';

export default {

  data() {
    return {
      loading: false,
      showModal: false,
      showPassword: false,
      isBlocked: false,
      disabledDates: false,
      editPago: false,
      roles: Rol,
      asesores: [],
      paquetes: [],
      docs: [],
      tipoPlanes: [],
      asesorCurrent: {},
      contratodb: {},
      contrato: {},
      direcciones: [],
      errores: {},
      erroresDirecciones: [],
      serie: {
        factura: null,
        boleta: null,
        notaCredito: null,
        notaDebito: null,
        observaciones: null
      },
      contacto: {
        documento: null,
        nombre: null,
        telefono: null,
        correo: null,
        cargo: null
      },
      sunat: {
        usuario: null,
        clave: null
      },
      usuario: authService.getUser(),
      filePago: null
    }
  },
  async mounted() {
    const id = this.$route.params.id;
    if (id && (isNaN(id) || id <= 0)) {
      this.$router.push({
        path: '/not-found'
      });
      return;
    }
    await this.getUsuarios();
    await this.getPaquetes();
    await this.getDocumentos();
    await this.getTipoPlanes();
    await this.getContratoPorId(id);
  },
  methods: {
    async getPaquetes() {
      this.paquetes = await ClientesService.getPaquetes();
    },
    async getDocumentos() {
      this.docs = await ClientesService.getDocumentos();
    },
    async getTipoPlanes() {
      this.tipoPlanes = await ClientesService.getTipoPlanes();
    },
    async getUsuarios() {
      let res = await ClientesService.getUsuarios(PaginacionDefault.FILTRO, PaginacionDefault.PAGINA, PaginacionDefault.SIZE, PaginacionDefault.ESTADO);
      let values = res.data || [];
      this.asesores = values.map(map => {
        return { label: map.nombre, value: map.id }
      });
      this.asesorCurrent = this.asesores.find(fnd => fnd.value == this.usuario.idUsuario);
    },
    async getContratoPorId(id) {
      let res = await ClientesService.getContratoPorId(id);
      this.contratodb = res;
      this.contrato.id = res.id;
      this.contrato.ruc = res.ruc;
      this.contrato.razonSocial = res.razonSocial;
      this.contrato.idAsesor = res.idAsesor;
      this.contrato.idPaquete = res.idPaquete;
      this.contrato.numSucursales = res.numSucursales;
      this.contrato.numUsuarios = res.numUsuarios || 'ILIMITADO';
      this.contrato.numComprobantes = res.numComprobantes || 'ILIMITADO';
      this.contrato.idDocsInternos = res.idDocsInternos;
      this.contrato.docInternos = res.soloDocsInternos == VALOR_NUMERICO_TRUE;
      this.contrato.idTipoPlan = res.idTipoPlan;
      this.contrato.costoMensual = res.costoMensual;
      this.contrato.costoPlan = res.costoPlan;
      this.contrato.costoInscripcion = res.costoInscripcion;
      this.contrato.inicioPromo = (res.fechaInicioPromo && Utils.formatFecha(res.fechaInicioPromo, 'yyyy-MM-dd')) || null;
      this.contrato.finPromo = (res.fechaFinPromo && Utils.formatFecha(res.fechaFinPromo, 'yyyy-MM-dd')) || null;
      this.contrato.inicioFacturacion = (res.fechaFacturacion && Utils.formatFecha(res.fechaFacturacion, 'yyyy-MM-dd')) || null;
      this.contrato.sinPromocion = res.fechaInicioPromo == null;
      this.contrato.observaciones = res.observaciones;

      this.contrato.nombreContrato = res.nombreContrato;
      this.contrato.nombrePago = res.nombrePago;
      this.contrato.nombreLogo = res.nombreLogo;
      this.contrato.nombreCapturaPSE = res.nombreCapturaPSE;

      this.direcciones = this.contratodb.direcciones.map(map => { return { id: map.id, estado: map.estado == VALOR_NUMERICO_TRUE, descripcion: map.descripcion } });

      let contactodb = (res.contactos && res.contactos[0]) || null;
      this.contacto.documento = (contactodb && contactodb.documento) || null;
      this.contacto.nombre = (contactodb && contactodb.razonSocial) || null;
      this.contacto.telefono = (contactodb && contactodb.telefono) || null;
      this.contacto.correo = (contactodb && contactodb.correo) || null;
      this.contacto.cargo = (contactodb && contactodb.cargo) || null;

      let sunatdb = (res.sunat && res.sunat[0]) || null;
      this.sunat.id = (sunatdb && sunatdb.id) || 0;
      this.sunat.usuario = 'ENCRYPTED';
      this.sunat.clave = 'ENCRYPTED';

      this.serie.factura = res.serieFactura || 'No utilizada';
      this.serie.boleta = res.serieBoleta || 'No utilizada';
      this.serie.notaCredito = res.serieNotaCredito || 'No utilizada';
      this.serie.notaDebito = res.serieNotaDebito || 'No utilizada';
      this.serie.observaciones = res.observacionesCliente;

      this.contrato.pathPago = res.nombrePago && res.nombrePago != '' ? `${STORAGE_URL}/${res.nombrePago}` : null;

    },
    btnAgregarDireccion_click() {
      this.isBlocked = this.direcciones.length > 9;
      if (!this.isBlocked) {
        this.direcciones.push({ id: 0, estado: false, descripcion: '' });
      }
    },
    ckbPromocion_click() {
      this.disabledDates = !this.disabledDates;
      if (this.disabledDates) {
        this.contrato.inicioPromo = null;
        this.contrato.finPromo = null;
      }
    },
    inpFileUpload_handle(event) {
      this.filePago = event.target.files[0];
    },
    async btnSubirPago() {
      const formData = new FormData();
      formData.append('file', this.filePago);
      let res = await ClientesService.uploadPagoContrato(this.contrato.id, formData);
      if (res) {
        Utils.mostrarMensajeExito('El archivo de Pago ha sido actualizado')
        this.$router.push({
        path: '/'
      });
      }
    },
    btnCancelar_click() {
      this.$router.go(-1);
    },
    async btnGuardar_click() {
      if (this.loading) return;
      //VALIDACIONES
      this.errores.idasesor = Rol.ADMINISTRADOR == this.usuario.rol
        && (this.contrato.idAsesor == null || this.contrato.idAsesor == -1);
      this.errores.ruc = this.contrato.ruc == null || this.contrato.ruc.trim() == '';
      this.errores.razonSocial = this.contrato.razonSocial == null || this.contrato.razonSocial.trim() == '';
      this.erroresDirecciones = this.direcciones.map(map => { return map.descripcion == null || map.descripcion.trim() == '' });
      this.errores.paquete = this.contrato.idPaquete == null || this.contrato.idPaquete == -1;
      this.errores.sucursales = this.contrato.numSucursales == null || this.contrato.numSucursales <= 0;
      this.errores.usuarios = this.contrato.numUsuarios == null
        || (isNaN(this.contrato.numUsuarios) && this.contrato.numUsuarios.trim() == '')
        || (!isNaN(this.contrato.numUsuarios) && this.contrato.numUsuarios <= 0);
      this.errores.numComprobantes = this.contrato.numComprobantes == null
        || (isNaN(this.contrato.numComprobantes) && this.contrato.numComprobantes.trim() == '')
        || (!isNaN(this.contrato.numComprobantes) && this.contrato.numComprobantes <= 0);
      this.errores.doc = this.contrato.idDocsInternos == null || this.contrato.idDocsInternos == -1;
      this.errores.plan = this.contrato.idTipoPlan == null || this.contrato.idTipoPlan == -1;
      this.errores.costoPlan = this.contrato.costoPlan == null || this.contrato.costoPlan < 0;
      this.errores.costoMensual = this.contrato.costoMensual == null || this.contrato.costoMensual < 0;
      this.errores.costoInscripcion = this.contrato.costoInscripcion == null || this.contrato.costoInscripcion < 0;
      this.errores.inicioPromo = !this.disabledDates && (this.contrato.inicioPromo == null || this.contrato.inicioPromo.trim() == '');
      this.errores.finPromo = !this.disabledDates && (this.contrato.finPromo == null || this.contrato.finPromo.trim() == '');
      this.errores.inicioFacturacion = this.contrato.inicioFacturacion == null || this.contrato.inicioFacturacion.trim() == '';

      let existError = Object.keys(this.errores).some(key => this.errores[key]);
      let existErrorDireccion = this.erroresDirecciones.some(key => key);
      if (existError) return;
      if (existErrorDireccion) return;
      console.log("ok")

      this.loading = true;
      spinnerService.show();

      try {
        
        //Lista de direcciones
        let listadirecciones = this.direcciones.map(map => { return { IdDireccion: map.id, Estado: map.estado ? 1 : 0, Descripcion: map.descripcion } });
        
        //Construyento el Objeto a guardar
        let obj = {
          IdAsesor: this.contrato.idAsesor == -1 ? this.asesorCurrent.value : this.contrato.idAsesor,
          Ruc: this.contrato.ruc,
          RazonSocial: this.contrato.razonSocial,
          IdPaquete: this.contrato.idPaquete,
          NumSucursales: this.contrato.numSucursales,
          NumComprobantes: isNaN(this.contrato.numComprobantes) ? null : this.contrato.numComprobantes,
          NumUsuarios: isNaN(this.contrato.numUsuarios) ? null : this.contrato.numUsuarios,
          IdDocInterno: this.contrato.idDocsInternos,
          SoloDocsInternos: this.contrato.docInternos ? 1 : 0,
          IdTipoPlan: this.contrato.idTipoPlan,
          CostoPlan: this.contrato.costoPlan,
          CostoMensual: this.contrato.costoMensual,
          CostoInscripcion: this.contrato.costoInscripcion,
          FechaInicioPromo: this.contrato.inicioPromo,
          FechaFinPromo: this.contrato.finPromo,
          FechaFacturacion: this.contrato.inicioFacturacion,
          Observaciones: this.contrato.observaciones,
          Direcciones: listadirecciones,

          FechaContrato: this.contratodb.fechaContrato      
        }
        await ClientesService.updateContrato(this.contratodb.id,obj);
        Utils.mostrarMensajeExitoConTitulo('Editado correctamente','Los datos han sido guardados');
        this.loading = false;
        this.$router.push({
          path: `/info/contratos`
        });
      } catch (error) {
        this.loading = false;
        Utils.mostrarMensajeError(error.Message || 'Ocurrió un error')
      } finally{
        spinnerService.hide();
      }

    }
  }
};

</script>
<template>
  <div class="space"></div>

  <template v-if="contrato">
    <div id="myModal" class="modal" v-if="showModal">
      <div class="modal-flex">
        <div class="inside">
          <span class="close-mod" @click="showModal = false">×</span>
          <img class="modal-content" id="imgMod" :src="contrato.pathPago" :alt="'Pago ' + contrato.ruc">
          <div id="caption">{{ 'Pago ' + contrato.ruc }}</div>
        </div>
      </div>
    </div>
    <div class="container conts">
      <div class="row">
        <div class="col"></div>
        <div class="col-sm-9">
          <div class="recuadro bg-white mt-5 mb-5">
            <div class="text-center head bg-primary bg-gradient text-white p-4">
              <h1>Editar Contrato</h1>
              <p>Cliente: {{ contrato.razonSocial }}</p>
            </div>
            <div class="card-body p-5">
              <form action="/editar-contrato" id="regis" method="POST" enctype="multipart/form-data">
                <div class="mb-3 bg-light p-3 rounded-3">
                  <div class="row">
                    <div class="col">
                      <label for="asesor" class="form-label form-control-lg">Asesor de Ventas</label>
                    </div>
                    <div class="col-sm-7">
                      <select v-if="usuario.rol == roles.ADMINISTRADOR" name="cnt_ase" id="cnt_ase"
                        class="req form-select form-control-lg" v-model="contrato.idAsesor"
                        v-bind:class="{ 'invalid': errores.idasesor }">
                        <option value="">Seleccione un asesor</option>
                        <option v-for="asesor in asesores" :key="asesor.value" :value="asesor.value">
                          {{ asesor.label }}
                        </option>
                      </select>
                      <template v-else>
                        <input type="text" class="form-control form-control-lg" :value="asesorCurrent.label" disabled
                          v-bind:class="{ 'invalid': errores.idasesor }">
                        <input type="hidden" name="cnt_ase" id="cnt_ase" class="form-control form-control-lg"
                          :value="asesorCurrent.value">
                      </template>

                    </div>
                  </div>
                </div>
                <div class="mb-3">
                  <div class="row">
                    <div class="col">
                      <h2>Información del cliente</h2>
                    </div>
                  </div>
                </div>
                <div class="mb-3 bg-light p-3 rounded-3">
                  <div class="row">
                    <div class="col">
                      <label for="con_ruc" class="form-label form-control-lg">RUC</label>
                    </div>
                    <div class="col-sm-7">
                      <input type="text" class="req form-control form-control-lg" name="cnt_ruc" id="cnt_ruc"
                        v-model="contrato.ruc" v-bind:class="{ 'invalid': errores.ruc }" maxlength="11">
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <label for="con_razsoc" class="form-label form-control-lg">Razón Social</label>
                    </div>
                    <div class="col-sm-7">
                      <input type="text" class="req form-control form-control-lg" name="cnt_razsoc" id="cnt_razsoc"
                        v-model="contrato.razonSocial" v-bind:class="{ 'invalid': errores.razonSocial }" maxlength="255">
                    </div>
                  </div>
                </div>
                <div class="mb-3">
                  <div class="row">
                    <div class="col">
                      <h2>Direcciones SUNAT</h2>
                    </div>
                  </div>
                </div>
                <div class="mb-3 bg-light p-3 rounded-3">
                  <div class="row" v-for="direccion, i in direcciones" v-bind:key="i">
                    <div class="col">
                      <label for="direc" class="form-label form-control-lg">Dirección SUNAT {{ i + 1 }}</label>
                    </div>
                    <div class="col-sm-7">
                      <div class="input-group mb-3">
                        <div class="input-group-text">
                          <input :name="'dir' + (i + 1)" :id="'dir' + (i + 1)" class="form-check-input mt-0"
                            type="checkbox" v-model="direccion.estado">
                        </div>
                        <input type="text" class="form-control form-control-lg" :name="'dir_des' + (i + 1)"
                          :id="'dir_des' + (i + 1)" v-model="direccion.descripcion"
                          v-bind:class="{ 'invalid': erroresDirecciones[i] }" maxlength="255">
                      </div>
                    </div>
                  </div>

                  <template v-if="direcciones.length < 10">

                    <div class="row">
                      <div class="col"></div>
                      <div class="col-sm-7">
                        <button type="button" id="add-d" class="btn btn-success form-control btn-lg"
                          @click="btnAgregarDireccion_click">Agregar dirección</button>
                      </div>
                    </div>
                  </template>
                </div>
                <div class="mb-3">
                  <div class="row">
                    <div class="col">
                      <h2>Información del paquete contratado</h2>
                    </div>
                  </div>
                </div>
                <div class="mb-3 bg-light p-3 rounded-3">
                  <div class="row">
                    <div class="col">
                      <label for="paquete" class="form-label form-control-lg">Paquete</label>
                    </div>
                    <div class="col-sm-7">
                      <select name="cnt_pkt" id="cnt_pkt" class="req form-select form-control-lg"
                        v-model="contrato.idPaquete" v-bind:class="{ 'invalid': errores.paquete }">
                        <option v-for="paquete in paquetes" :key="paquete.value" :value="paquete.value">
                          {{ paquete.label }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <label for="con_suc" class="form-label form-control-lg">Sucursales</label>
                    </div>
                    <div class="col-sm-7">
                      <input type="text" class="req form-control form-control-lg" name="cnt_suc" id="cnt_suc"
                        v-model="contrato.numSucursales" maxlength="50" v-bind:class="{ 'invalid': errores.sucursales }">
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <label for="con_can" class="form-label form-control-lg">Cantidad de usuarios</label>
                    </div>
                    <div class="col-sm-7">
                      <input type="text" class="req form-control form-control-lg" name="cnt_cnt_usu" id="cnt_cnt_usu"
                        v-model="contrato.numUsuarios" maxlength="20" v-bind:class="{ 'invalid': errores.usuarios }">
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <label for="con_com" class="form-label form-control-lg">Cantidad de comprobantes</label>
                    </div>
                    <div class="col-sm-7">
                      <input type="text" class="req form-control form-control-lg" name="cnt_cnt_com" id="cnt_cnt_com"
                        v-model="contrato.numComprobantes" maxlength="20"
                        v-bind:class="{ 'invalid': errores.numComprobantes }">
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <label for="docs" class="form-label form-control-lg">Documentos internos</label>
                    </div>
                    <div class="col-sm-7">
                      <select name="cnt_doc" id="cnt_doc" class="form-control-lg form-select"
                        v-model="contrato.idDocsInternos" v-bind:class="{ 'invalid': errores.doc }">
                        <option v-for="doc in docs" :key="doc.value" :value="doc.value">
                          {{ doc.label }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <label for="con_com" class="form-label form-control-lg">Solo documentos internos</label>
                    </div>
                    <div class="col-sm-7">
                      <input name="cnt_doc_int" id="cnt_doc_int" class="form-control-lg form-check-input" type="checkbox"
                        v-model="contrato.docInternos">
                    </div>
                  </div>
                </div>
                <div class="mb-3 bg-light p-3 rounded-3">
                  <div class="row">
                    <div class="col">
                      <div class="input-group">
                        <label for="con_plan" class="form-control-lg">Costo</label>
                        <select name="cnt_tip_plan" id="cnt_tip_plan" class="form-select form-control-lg"
                          v-model="contrato.idTipoPlan" v-bind:class="{ 'invalid': errores.plan }">

                          <option value="">Seleccione el Plan</option>
                          <option v-for="tipoPlan in tipoPlanes" :key="tipoPlan.value" :value="tipoPlan.value">
                            {{ tipoPlan.label }}
                          </option>
                        </select>
                      </div>
                    </div>
                    <div class="col-sm-7">
                      <div class="input-group">
                        <span class="soles input-group-text fw-bold">S/.</span>
                        <input type="text" class="inpsol req form-control form-control-lg" name="cnt_cos_plan"
                          id="cnt_cos_plan" v-model="contrato.costoPlan" v-bind:class="{ 'invalid': errores.costoPlan }"
                          maxlength="20">
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <label for="con_men" class="form-label form-control-lg">Costo mensual</label>
                    </div>
                    <div class="col-sm-7">
                      <div class="input-group">
                        <span class="soles input-group-text fw-bold">S/.</span>
                        <input type="text" class="inpsol req form-control form-control-lg" name="cnt_cos_men"
                          id="cnt_cos_men" v-model="contrato.costoMensual"
                          v-bind:class="{ 'invalid': errores.costoMensual }" maxlength="20">
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <label for="con_ins" class="form-label form-control-lg">Costo de inscripción</label>
                    </div>
                    <div class="col-sm-7">
                      <div class="input-group">
                        <span class="soles input-group-text fw-bold">S/.</span>
                        <input type="text" class="inpsol req form-control form-control-lg" name="cnt_cos_ins"
                          id="cnt_cos_ins" v-model="contrato.costoInscripcion"
                          v-bind:class="{ 'invalid': errores.costoInscripcion }" maxlength="20">
                      </div>
                    </div>
                  </div>
                </div>
                <div class="mb-3">
                  <div class="row">
                    <div class="col">
                      <h2>Información adicional</h2>
                    </div>
                  </div>
                </div>
                <div class="mb-3 bg-light p-3 rounded-3">
                  <div class="row">
                    <div class="col">
                      <label for="con_ini" class="form-control-lg">Inicio promo</label>
                    </div>
                  <div class="col-sm-7">
                      <input type="date" class="form-control form-control-lg"
                        v-bind:class="{ 'invalid': errores.inicioPromo }" name="cnt_ini" id="cnt_ini"
                        v-model="contrato.inicioPromo" :disabled="disabledDates">
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <label for="con_fin" class="form-control-lg">Fin promo</label>
                    </div>
                    <div class="col-sm-7">
                      <input type="date" class="form-control form-control-lg"
                        v-bind:class="{ 'invalid': errores.finPromo }" name="cnt_fin" id="cnt_fin"
                        v-model="contrato.finPromo" :disabled="disabledDates">
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <label for="con_pri" class="form-control-lg">Fecha inicio facturación</label>
                    </div>
                    <div class="col-sm-7">
                      <input type="date" class="req form-control form-control-lg" name="cnt_fec" id="cnt_fec"
                        v-model="contrato.inicioFacturacion" v-bind:class="{ 'invalid': errores.inicioFacturacion }">
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <label for="con_com" class="form-control-lg">Sin promoción</label>
                  </div>
                    <div class="col-sm-7 form-check form-switch">
                      <input name="cnt_no_pro" id="cnt_no_pro" class="form-check-input" type="checkbox"
                        @change="ckbPromocion_click" v-model="contrato.sinPromocion" value="S">
                    </div>
                  </div>
                </div>

                <div class="mb-3">
                  <div class="row">
                    <div class="col">
                      <h2>Datos de Configuración</h2>
                    </div>
                  </div>
                </div>
                <div class="mb-3 bg-light p-3 rounded-3">
                  <div class="row">
                    <div class="col">
                      <label for="contac" class="form-label form-control-lg">DNI de la persona de contacto</label>
                    </div>
                    <div class="col-sm-7">
                      <input type="text" class="form-control form-control-lg" name="con_dni" id="con_dni"
                        v-model="contacto.documento" disabled>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <label for="contac" class="form-label form-control-lg">Nombre</label>
                    </div>
                    <div class="col-sm-7">
                      <input type="text" class="form-control form-control-lg" name="con_nom" id="con_nom"
                        v-model="contacto.nombre" disabled>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <label for="contac" class="form-label form-control-lg">Teléfono</label>
                    </div>
                    <div class="col-sm-7">
                      <input type="text" class="form-control form-control-lg" name="con_tel" id="con_tel"
                        v-model="contacto.telefono" disabled>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <label for="contac" class="form-label form-control-lg">Correo Eletrónico</label>
                    </div>
                    <div class="col-sm-7">
                      <input type="text" class="form-control form-control-lg" name="con_ema" id="con_ema"
                        v-model="contacto.correo" disabled>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <label for="contac" class="form-label form-control-lg">Cargo en la empresa</label>
                    </div>
                    <div class="col-sm-7">
                      <input type="text" class="form-control form-control-lg" name="con_car" id="con_car"
                        v-model="contacto.cargo" disabled>
                    </div>
                  </div>
                </div>
                <div class="mb-3 bg-light p-3 rounded-3">
                  <div class="row">
                    <div class="col">
                      <label for="contac" class="form-label form-control-lg">Usuario</label>
                    </div>
                    <div class="col-sm-7">
                      <input :type="showPassword ? 'text' : 'password'" class="form-control form-control-lg" name="sun_usr" id="sun_usr"
                        v-model="sunat.usuario" disabled>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <label for="contac" class="form-label form-control-lg">Clave Sol</label>
                    </div>
                    <div class="col-sm-7">
                      <div class="input-group mb-3">
                        <input :type="showPassword ? 'text' : 'password'" class="form-control form-control-lg" name="sun_sol" id="sun_sol"
                          v-model="sunat.clave" disabled>
                        <button class="btn btn-outline-secondary btn-lg" type="button" id="show" @click="showPassword = !showPassword"><i
                            id="icon" class="fas" v-bind:class="{ 'fa-eye-slash': !showPassword, 'fa-eye': showPassword }"></i></button>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="mb-3 bg-light p-3 rounded-3">
                  <div class="row">
                    <div class="col">
                      <label for="cnt_doc_con" class="form-label form-control-lg">Facturas</label>
                    </div>
                    <div class="col-sm-7">
                      <input type="text" class="form-control form-control-lg" name="cnt_ser_fac" id="cnt_ser_fac"
                        v-model="serie.factura" style="text-transform: uppercase" disabled>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <label for="cnt_doc_con" class="form-label form-control-lg">Boletas</label>
                    </div>
                    <div class="col-sm-7">
                      <input type="text" class="form-control form-control-lg" name="cnt_ser_bol" id="cnt_ser_bol"
                        v-model="serie.boleta" style="text-transform: uppercase" disabled>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <label for="cnt_doc_con" class="form-label form-control-lg">Nota de Crédito</label>
                    </div>
                    <div class="col-sm-7">
                      <input type="text" class="form-control form-control-lg" name="cnt_ser_cre" id="cnt_ser_cre"
                        v-model="serie.notaCredito" style="text-transform: uppercase" disabled>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <label for="cnt_doc_con" class="form-label form-control-lg">Nota de Débito</label>
                    </div>
                    <div class="col-sm-7">
                      <input type="text" class="form-control form-control-lg" name="cnt_ser_deb" id="cnt_ser_deb"
                        v-model="serie.notaDebito" style="text-transform: uppercase" disabled>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <label for="con_obs" class="form-label form-control-lg">Observaciones del cliente</label>
                    </div>
                    <div class="col-sm-7">
                      <textarea name="cnt_obs" class="form-control form-control-lg" id="cnt_obs_cli" rows="1"
                        v-model="serie.observaciones" disabled></textarea>
                    </div>
                  </div>
                </div>
                <div class="mb-3 bg-light p-3 rounded-3">
                  <div class="row">
                    <div class="col">
                      <label for="con_obs" class="form-label form-control-lg">Observaciones vendedor</label>
                    </div>
                    <div class="col-sm-7">
                      <textarea name="cnt_obs" class="form-control form-control-lg" id="cnt_obs" rows="3"
                        v-model="contrato.observaciones" maxlength="255"></textarea>
                    </div>
                  </div>
                </div>
              </form>
              <div class="mb-3">
                <div class="row">
                  <div class="col">
                    <h2>Archivos</h2>
                  </div>
                </div>
              </div>
              <form action="/actualizar-cont" id="reg-cont" method="POST" enctype="multipart/form-data">
                <div class="mb-3 bg-light p-3 rounded-3">
                  <div class="row">
                    <div class="col">
                      <label for="cnt_doc_con" class="form-label form-control-lg">Contrato</label>
                    </div>
                    <div class="col-sm-7">
                      <div class="input-group">
                        <a href="https://smartregistro.s3.us-west-2.amazonaws.com/Terminos%20y%20condiciones%20SMART%20CLIC%202022.pdf"
                          target="_blank" class="btn btn-success form-control btn-lg" title="Descargar Contrato"><i
                            class="fas fa-download"></i></a>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col"></div>
                    <div class="col-sm-7">
                      <div class="input-group">
                        <input type="file" class="form-control form-control-lg" id="cnt_doc_cnt" style="display: none;">
                        <button id="act_cont" type="button" class="btn btn-success btn-lg" onclick="actCont()"
                          style="display: none;" title="Guardar Nuevo Contrato"><i class="fas fa-save"></i></button>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
              <form action="/actualizar-pago" id="reg-pago" method="POST" enctype="multipart/form-data">
                <div class="mb-3 bg-light p-3 rounded-3">
                  <div class="row">
                    <div class="col">
                      <label for="cnt_doc_con" class="form-label form-control-lg">Pago</label>
                    </div>
                    <div class="col-sm-7">
                      <div class="input-group">
                        <template v-if="contrato.pathPago != null && contrato.pathPago != ''">
                          <a class="btn btn-success form-control btn-lg" @click="showModal = true" title="Ver Pago"><i
                              class="fas fa-eye"></i></a>
                        </template>
                        <button id="actp" type="button" class="btn form-control btn-lg"
                          v-bind:class="{ 'btn-primary': !editPago, 'btn-danger': editPago }"
                          @click="editPago = !editPago" title="Editar Pago"><i id="ico-act" class="fas"
                            v-bind:class="{ 'fa-edit': !editPago, 'fa-ban': editPago }"></i></button>
                      </div>
                    </div>
                  </div>
                  <div class="row" v-if="editPago">
                    <div class="col"></div>
                    <div class="col-sm-7">
                      <div class="input-group">
                        <input type="file" class="form-control form-control-lg" id="cnt_doc_pag" name="file"
                          v-bind:class="{ 'requerido': !editPago }" @change="inpFileUpload_handle">
                        <button id="act_pago" type="button" class="btn btn-success btn-lg" @click="btnSubirPago"
                          title="Guardar Nuevo Pago"><i class="fas fa-save"></i></button>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
              <div class="mb-3">
                <div class="row">
                  <div class="col"><a @click="btnCancelar_click"
                      class="btn btn-danger form-control btn-lg">Atras</a></div>
                  <div class="col"></div>
                  <div class="col"><button type="button" class="btn btn-primary form-control btn-lg"
                    @click="btnGuardar_click">Guardar</button></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col"></div>
      </div>
    </div>
  </template>
</template>